<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/admin/overview">
        <p>الرئيسية</p>
        <i class="fas fa-home"></i>
      </sidebar-link>
      <sidebar-link to="/admin/user">
        <i class="fas fa-user"></i>
        <p>حسابي</p>
      </sidebar-link>
      <sidebar-link to="/admin/users" v-if="decodedToken == 'ادمن'">
        <i class="fas fa-users"></i>
        <p>المستخدمون</p>
      </sidebar-link>
      <sidebar-link to="/admin/categories">
        <i class="fas fa-sitemap"></i>
        <p>الأقسام</p>
      </sidebar-link>
      <sidebar-link to="/admin/products">
        <i class="fas fa-shopping-cart"></i>
        <p>المنتجات</p>
      </sidebar-link>
      <sidebar-link to="/admin/materials">
        <i class="fas fa-tools"></i>
        <p>الخامات</p>
      </sidebar-link>
      <sidebar-link to="/admin/offers">
        <i class="fas fa-dollar-sign"></i>
        <p>العروض</p>
      </sidebar-link>
      <sidebar-link to="/admin/general-setting">
        <i class="fas fa-cog"></i>
        <p>الإعدادات العامة</p>
      </sidebar-link>
    </side-bar>
    <div
      :class="{
        'main-panel': !$sidebar.showSidebar,
        'main-panel main-panel-none': $sidebar.showSidebar,
      }"
    >
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar"> </dashboard-content>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu.vue";
import jwt_decode from "jwt-decode";

export default {
  data() {
    return {
      token: null,
      decodedToken : null
    };
  },
  created() {
    this.token = localStorage.getItem("adminToken");
    this.decodedToken = this.token ? jwt_decode(this.token).role : null;
  },
  components: {
    TopNavbar,
    DashboardContent,
    MobileMenu,
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
